import { useState } from 'react';
import { useHistory } from 'react-router-dom';

import { UserRoles } from 'components/AdminControls/data';
import Navbar from 'components/Navbar';
import { ConfirmPopup, NotificationPopup } from 'components/Popups';
import { Logo } from 'components/Reusable';
import Toolbar from 'components/Toolbar';

import { useMemoSelector } from 'hooks';
import Api from 'services/Api';
import { getUserRole } from 'store';
import { Paths, UserRoleCodes } from 'utils';

import { ReactComponent as WarningIcon } from 'assets/warning.svg';
import globalStyles from 'styles/modules/Global.module.scss';
import styles from './Header.module.scss';

const Header = (): JSX.Element => {
  const history = useHistory();

  const userRole = useMemoSelector(getUserRole);

  const [isOpenConfirmRequestAccess, setIsOpenConfirmRequestAccess] = useState(false);
  const [isOpenNotificationPopup, setIsOpenNotificationPopup] = useState(false);

  const onRequestAccess = async () => {
    const res = await Api.requestAccessUser();
    if (!res) return;

    setIsOpenConfirmRequestAccess(false);
    setIsOpenNotificationPopup(true);
  };

  return (
    <div className={styles.headerContainer}>
      <Logo onClick={() => history.push(Paths.dashboard)} />
      {[UserRoleCodes.ArrowReadOnly, UserRoles.ARROW_READ].includes(userRole as unknown as UserRoles) && (
        <div className={styles.warningContainer} onClick={() => setIsOpenConfirmRequestAccess(true)}>
          <WarningIcon />
          <p className={globalStyles.f11h13SuisseREG_gray}>Read-Only</p>
        </div>
      )}
      <Navbar />
      <Toolbar />
      <ConfirmPopup
        isOpen={isOpenConfirmRequestAccess}
        setIsOpen={setIsOpenConfirmRequestAccess}
        questionText="Request Team Access?"
        mainText="You are requesting team-member access that will give you rights to edit the system"
        btnDoneText="Request Access"
        onClickSubmit={onRequestAccess}
      />
      <NotificationPopup isOpen={isOpenNotificationPopup} setIsOpen={setIsOpenNotificationPopup} text="Request Sent" />
    </div>
  );
};

export default Header;
